import { getSdk, sdkOpts } from "./sdk";
const sdk = getSdk(sdkOpts());
export const getHistoricalContent = (query) => sdk.GetHistoricalContent.queryAsPromise(query).then(r => r.data?.pubsub?.query || { items: [], page: { nextToken: null } });
export const getSitemapContent = (query) => sdk.GetSitemapContent.queryAsPromise(query).then(r => r.data?.pubsub?.query?.items || []);
//# sourceMappingURL=PubSub.js.map